import { Component, Inject, Input, forwardRef, OnInit, ElementRef } from '@angular/core';
import { HomeComponent } from './app.home.component';
declare var $: any;
@Component({
  selector: 'app-help-notification-modal-placeholder',
  templateUrl: './app.notification.modal.compnent.html'
})
// the Modal import allows the usage of the @Modal alias that adds the Modal functions.

export class HelpNotificationModalComponent implements OnInit {

  @Input() message;

  closeModal: Function;

  // Will fetch the userCreds passed from the callback.
  userCreds;
  element = null;
  constructor( @Inject(forwardRef(() => HomeComponent)) private homeComponent: HomeComponent, private el: ElementRef) {

    this.element = $(el.nativeElement);
  }


  ngOnInit(): void {
    const parent = this.homeComponent;
    this.element.on('click', function (e: any) {
      const target = $(e.target);

      if (!target.closest('.PopUpContainer').length) {
        this.card = null;
        parent.showNotificationModal = false;
      }
    });
  }
  closeThisDialogModal() {


    this.homeComponent.showNotificationModal = false;
  }
}



// WEBPACK FOOTER //
// C:/Websites/Planeto/PlanetoAngular/src/app/app.help.notificationModal.compnent.ts